export default "__VITE_ASSET__BJ15EFCe__"